'use client';
import React from 'react';

import ListPage from '@/components/page-components/list-page/list-page';
import {
  createListCardArray,
  serializeListCardDateTimes,
} from '@/helpers/list-page/list-page-helpers';
import { IMeetingPlacePageEditorialList } from '@/lib/fragments/meetingPlacePageEditorialsList';
import { IMeetingplacePageHomeMinifiedExtendedLogo } from '@/lib/fragments/meetingPlacePageHome-minified';
import useGetMobileAppWebViewHeader from '@/hooks/use-get-mobile-app-web-view';
import { useTenantConfig } from '@/providers/ConfigProvider';
import { GtmPageView } from '@/components/page-components/analytics/gtm-page-view';

interface MeetingPlacePageEditorialListProps {
  metaData: any;
  node_locale: string;
  preview?: boolean;
  editorialListData: {
    meetingPlacePageEditorialList: IMeetingPlacePageEditorialList;
    meetingPlacePageHomeCollection: IMeetingplacePageHomeMinifiedExtendedLogo;
  };
  initialPage?: number;
}

const MeetingPlacePageEditorialsList = ({
  metaData,
  node_locale,
  editorialListData,
  initialPage,
}: MeetingPlacePageEditorialListProps) => {
  const config = useTenantConfig();
  const prefix = config?.GATSBY_SITE_PATH_PREFIX || '';
  const page = editorialListData?.meetingPlacePageEditorialList;
  const homepage = editorialListData?.meetingPlacePageHomeCollection;
  const editorialItemPages =
    page?.editorialPageListCollection?.items?.filter(Boolean) || [];

  const editorialItemCardList = createListCardArray(
    editorialItemPages,
    undefined,
    undefined,
    undefined,
    node_locale,
    prefix,
  );

  const isWebView = useGetMobileAppWebViewHeader();

  return (
    <>
      {/* ✅ GTM PAGE VIEW */}
      <GtmPageView
        homepage={homepage}
        language={node_locale}
        pageTitle={page?.name ?? ''}
      />
      <ListPage
        cardList={editorialItemCardList}
        pageName={page?.name}
        pageSlug={page?.slug}
        node_locale={node_locale}
        // location={location}
        breadcrumbs={[page?.name]}
        homeText={homepage?.breadcrumbHomeText ?? ''}
        tileColClass="grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
        listType="editorial"
        pageDescription={page?.description}
        isWebView={isWebView}
        initialPage={initialPage ?? 1}
      />
    </>
  );
};

export default MeetingPlacePageEditorialsList;
